<!--
The databoxes are created dynamically into the appDynamicContent anchor and
laid out as a wrapping flex row (see the stylesheet).

Nothing renders until a config with a non-empty componentArray arrives.
-->
@if (hasComponents()) {
  <div class="databox">
    <ng-template appDynamicContent />
  </div>
}
